import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'torchAbbreviations'
})
export class TorchAbbreviationsPipe implements PipeTransform {

  private abbreviations = {
    Mgmt: 'Management',
    Sr: 'Senior',
    mgmt: 'Management',
    sr: 'Senior',
  };

  transform(value: string, ...args: unknown[]): string {
    let returnValue = value;

    Object.keys(this.abbreviations).forEach(key => {
      returnValue = returnValue.replace(key, this.abbreviations[key]);
    });

    return  returnValue;
  }

}
